// ── Intranet ──
import { main } from './main.js'
import { people } from './people.js'
import { my } from './my.js'
import { announcements } from './announcements.js'
import { company } from './company.js'
import { data } from './data.js'

// ── Identity pages (consolidated in shared/pages/) ──
import { login, signin, signup, signupConfirmation, resetPassword, profile } from '../../shared/pages/identity-index.js'

// ── Calendar ──
import { home as calendar } from './calendar.js'

// ── Tickets ──
import { myView as tickets } from './tickets.js'
import { home as ticketsBoard } from './tickets/board.js'
import { general as ticketsGeneral } from './tickets/general.js'
import { feed as ticketsFeed } from './tickets/feed.js'
import { canvas as ticketsCanvas } from './tickets/canvas.js'
import { stories as ticketsStories } from './tickets/stories.js'
import { epics as ticketsEpics } from './tickets/epics.js'
import { standups as ticketsStandups } from './tickets/standups.js'
import { requests, requestsInbound, requestsOutbound, requestsAudit } from './tickets/requests.js'
import { resolutions, resolutionsImprovements, resolutionsEditRequests } from './tickets/resolutions.js'

// ── Chat ──
import { home as chat } from './chat.js'

// ── Documents ──
import { home as documents } from './documents.js'
import { notes as documentsNotes } from './documents/notes.js'
import { knowledgeBase as documentsKb } from './documents/knowledgeBase.js'
import { editor as documentsEditor } from './documents/editor.js'

// ── Meet ──
import { home as meet } from './meet.js'
import { guest as meetGuest } from './meet-guest.js'

// ── System ──
import { system } from './system.js'
import { features, ticketsStatus } from './features.js'

// ── Admin (moved to shared/pages/admin/) ──
import {
  admin,
  capTable,
  adminTeams,
  adminPermissions,
  adminActivityScoring,
  adminDanger,
  adminLogs,
  adminIntegrations,
  adminIntegrationsSupabase,
  adminIntegrationsGithub,
  adminIntegrationsGoogle,
  adminIntegrationsNpm,
  adminIntegrationsGeneric,
  adminIntegrationsMcp,
  adminStatus
} from '../../shared/pages/identity-index.js'
import { dataExternal } from './data-external.js'
import { sessionBridge } from './session-bridge.js'

export default {
  // Intranet
  '/': main,
  '/people': people,
  '/my': my,
  '/announcements': announcements,
  '/company': company,
  '/profile': profile,
  '/login': login,
  '/signin': signin,
  '/signup': signup,
  '/signup-confirmation': signupConfirmation,
  '/reset-password': resetPassword,
  '/data': data,
  '/data/projects': data,
  '/data/users': data,
  '/data/plans': data,
  '/data/organizations': data,
  '/data/teams': data,
  '/data/subscriptions': data,
  '/data/external': dataExternal,

  // Calendar
  '/calendar': calendar,

  // Tickets
  '/tickets': tickets,
  '/tickets/general': ticketsGeneral,
  '/tickets/feed': ticketsFeed,
  '/tickets/canvas': ticketsCanvas,
  '/tickets/stories': ticketsStories,
  '/tickets/epics': ticketsEpics,
  '/tickets/board': ticketsBoard,
  '/tickets/status': ticketsStatus,
  '/tickets/standups': ticketsStandups,

  // Requests
  '/tickets/requests': requests,
  '/tickets/requests/inbound': requestsInbound,
  '/tickets/requests/outbound': requestsOutbound,
  '/tickets/requests/audit': requestsAudit,

  // Resolutions
  '/tickets/resolutions': resolutions,
  '/tickets/resolutions/improvements': resolutionsImprovements,
  '/tickets/resolutions/edit-requests': resolutionsEditRequests,

  // Chat
  '/chat': chat,

  // Documents
  '/docs': documents,           // legacy route alias — /docs redirects to /documents
  '/documents': documents,
  '/documents/notes': documentsNotes,
  '/documents/knowledge-base': documentsKb,
  '/documents/kb': documentsKb,
  '/documents/editor': documentsEditor,

  // Meet
  '/meet': meet,
  '/meet-guest': meetGuest,

  // System
  '/system': system,
  '/features': features,

  // Admin
  '/admin': admin,
  '/admin/cap-table': capTable,
  '/admin/teams': adminTeams,
  '/admin/permissions': adminPermissions,
  '/admin/activity-scoring': adminActivityScoring,
  '/admin/logs': adminLogs,
  '/admin/integrations': adminIntegrations,
  '/admin/integrations/supabase': adminIntegrationsSupabase,
  '/admin/integrations/github': adminIntegrationsGithub,
  '/admin/integrations/google': adminIntegrationsGoogle,
  '/admin/integrations/npm': adminIntegrationsNpm,
  '/admin/integrations/openai': adminIntegrationsGeneric,
  '/admin/integrations/livekit': adminIntegrationsGeneric,
  '/admin/integrations/google_analytics': adminIntegrationsGeneric,
  '/admin/integrations/n8n': adminIntegrationsGeneric,
  '/admin/integrations/custom_http': adminIntegrationsGeneric,
  // Marketplace-seeded kinds (migration 0063). All use the generic
  // detail page — which reads config_schema.fields from the kind row
  // so no bespoke code per kind. Add to this list AND to 0063 together.
  '/admin/integrations/plausible': adminIntegrationsGeneric,
  '/admin/integrations/posthog': adminIntegrationsGeneric,
  '/admin/integrations/segment': adminIntegrationsGeneric,
  '/admin/integrations/mixpanel': adminIntegrationsGeneric,
  '/admin/integrations/firebase': adminIntegrationsGeneric,
  '/admin/integrations/cloudflare_workers': adminIntegrationsGeneric,
  '/admin/integrations/vercel': adminIntegrationsGeneric,
  '/admin/integrations/aws': adminIntegrationsGeneric,
  '/admin/integrations/postgres': adminIntegrationsGeneric,
  '/admin/integrations/mongodb': adminIntegrationsGeneric,
  '/admin/integrations/planetscale': adminIntegrationsGeneric,
  '/admin/integrations/neon': adminIntegrationsGeneric,
  '/admin/integrations/redis': adminIntegrationsGeneric,
  '/admin/integrations/zapier': adminIntegrationsGeneric,
  '/admin/integrations/make': adminIntegrationsGeneric,
  '/admin/integrations/temporal': adminIntegrationsGeneric,
  '/admin/integrations/auth0': adminIntegrationsGeneric,
  '/admin/integrations/clerk': adminIntegrationsGeneric,
  '/admin/integrations/workos': adminIntegrationsGeneric,
  '/admin/integrations/stripe': adminIntegrationsGeneric,
  '/admin/integrations/paddle': adminIntegrationsGeneric,
  '/admin/integrations/lemonsqueezy': adminIntegrationsGeneric,
  '/admin/integrations/anthropic': adminIntegrationsGeneric,
  '/admin/integrations/replicate': adminIntegrationsGeneric,
  '/admin/integrations/pinecone': adminIntegrationsGeneric,
  '/admin/integrations/slack': adminIntegrationsGeneric,
  '/admin/integrations/discord': adminIntegrationsGeneric,
  '/admin/integrations/twilio': adminIntegrationsGeneric,
  '/admin/integrations/sendgrid': adminIntegrationsGeneric,
  '/admin/integrations/resend': adminIntegrationsGeneric,
  '/admin/integrations/aws_s3': adminIntegrationsGeneric,
  '/admin/integrations/cloudflare_r2': adminIntegrationsGeneric,
  '/admin/integrations/uploadthing': adminIntegrationsGeneric,
  '/admin/integrations/sentry': adminIntegrationsGeneric,
  '/admin/integrations/datadog': adminIntegrationsGeneric,
  '/admin/integrations/logrocket': adminIntegrationsGeneric,
  '/admin/integrations/figma': adminIntegrationsGeneric,
  '/admin/integrations/mcp': adminIntegrationsMcp,
  '/admin/status': adminStatus,
  '/admin/danger': adminDanger,

  // Cross-origin auth helper. Other Symbols subdomains iframe this page
  // to request the live governance Supabase session, so e.g. the canvas
  // app can read RLS-gated integration rows without a separate signin.
  '/_session-bridge': sessionBridge
}
